import { SilverfinContext } from '../types/sf-data'

import { defineStore } from 'pinia'

import { ref } from 'vue'

export const useContext = defineStore('context', () => {
  const context = ref<{
    type: SilverfinContext
    id: number
  }>({
    type: SilverfinContext.None,
    id: 0,
  })

  const contextName = ref<string>('')

  function setContext(type: SilverfinContext, id: number): void {
    context.value = {
      type,
      id,
    }
  }

  function setContextName(name: string): void {
    contextName.value = name
  }

  return {
    context,
    setContext,
    contextName,
    setContextName,
  }
})
